/** Allegro marketplace hard limits — keep in sync with backend `allegro/limits.py`. */
export const ALLEGRO_MAX_OFFER_IMAGES = 16
